<template>
	<div style="visibility:hidden; opacity:0" id="dropzone">
		<div id="textnode">
			<v-icon size="33vh" color="white">play_for_work</v-icon>
		</div>
	</div>
</template>

<script>
export default {
	props: [ 'isActive' ],
	computed: {
		enabled () {
			if (this.isActive === undefined) {
				return true
			}
			return this.isActive
		}
	},
	methods: {
		containsFiles (event) {
			if (event.dataTransfer.types) {
				for (var i = 0; i < event.dataTransfer.types.length; i++) {
					if (event.dataTransfer.types[i] === 'Files') {
						return true
					}
				}
			}
			return false
		},
		onDragEnter (e) {
			let el = document.querySelector('#dropzone')
			if (this.enabled && el) {
				if (this.containsFiles(e)) {
					document.querySelector('#dropzone').style.visibility = ''
					document.querySelector('#dropzone').style.opacity = 1
					document.querySelector('#textnode').style.fontSize = '48px'
				}
			}
		},
		onDragLeave (e) {
			let el = document.querySelector('#dropzone')
			if (this.enabled && el) {
				e.preventDefault()
				document.querySelector('#dropzone').style.visibility = 'hidden'
				document.querySelector('#dropzone').style.opacity = 0
				document.querySelector('#textnode').style.fontSize = '42px'
			}
		},
		onDragOver (e) {
			let el = document.querySelector('#dropzone')
			if (this.enabled && el) {
				if (this.containsFiles(e)) {
					e.preventDefault()
					document.querySelector('#dropzone').style.visibility = ''
					document.querySelector('#dropzone').style.opacity = 1
					document.querySelector('#textnode').style.fontSize = '48px'
				}
			}
		},
		onDrop (e) {
			let el = document.querySelector('#dropzone')
			if (this.enabled && el) {
				if (this.containsFiles(e)) {
					e.preventDefault()
					document.querySelector('#dropzone').style.visibility = 'hidden'
					document.querySelector('#dropzone').style.opacity = 0
					document.querySelector('#textnode').style.fontSize = '42px'
					let files = e.dataTransfer.files
					this.$emit('droppedFiles', files)
				}
			}
		}
	},
	mounted () {
		window.addEventListener('dragenter', this.onDragEnter)
		window.addEventListener('dragleave', this.onDragLeave)
		window.addEventListener('dragover', this.onDragOver)
		window.addEventListener('drop', this.onDrop)
	},
	beforeDestroy () {
		window.removeEventListener('dragenter', this.onDragEnter)
		window.removeEventListener('dragleave', this.onDragEnter)
		window.removeEventListener('dragover', this.onDragEnter)
		window.removeEventListener('drop', this.onDragEnter)
	}
}
</script>

<style scoped lang="stylus">
div#dropzone
	position: fixed
	top: 0
	left: 0
	z-index: 9999999999
	width: 100%
	height: 100%
	background-color: rgba(0, 0, 0, 0.5)
	transition: visibility 175ms, opacity 175ms
	display: table
	text-shadow: 1px 1px 2px #000
	color: #fff
	background: rgba(0, 0, 0, 0.45)

div#textnode
	display: table-cell
	text-align: center
	vertical-align: middle
	transition: size 175ms

</style>



// WEBPACK FOOTER //
// src/components/drop_file_zone.vue